<template>
  <head>
    <title>{{ $t("dashboard.services") }}</title>
  </head>
  <div class="services-view">
    <SideBar>
      <div class="container bg-light h-100 overflow-scroll">
        <div class="d-flex justify-content-center align-items-center mt-5 mb-3">
          <div class="w-100 d-flex justify-content-start align-items-center">
            <h3>{{ $t("dashboard.services") }} ({{ data.length }})</h3>
          </div>
          <div class="w-100 d-flex justify-content-end align-items-center">
            <button
              type="button"
              class="add-btn"
              @click="$router.push('/admin-add-services')"
            >
              {{ $t("dashboard.AddServices") }}
            </button>
          </div>
        </div>
        <div class="search-bar w-100 my-4">
          <input
            type="text"
            class="my-inp w-50"
            style="border: 1px solid black"
            :placeholder="$t('dashboard.SearchServices')"
            v-model="search_for"
            v-on:input="SearchByName()"
          />
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("dashboard.NameAr") }}</th>
                <th scope="col">{{ $t("dashboard.NameEn") }}</th>
                <th scope="col">{{ $t("dashboard.icon") }}</th>
                <th scope="col">{{ $t("dashboard.edit") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in shown_data" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>{{ item.name_ar }}</td>
                <td>{{ item.name_en }}</td>
                <td>
                  <Icon :icon="item.icon" heighet="24" width="24" />
                </td>
                <td>
                  <button
                    type="button"
                    @click="$router.push('/admin-add-services?id=' + item.id)"
                    class="btn btn-outline-success"
                  >
                    {{ $t("dashboard.edit") }}
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    @click="DeleteService(item.id)"
                  >
                    {{ $t("dashboard.delete") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </SideBar>
  </div>
</template>

<script>
import SideBar from "@/components/AdminDashboard/SideBar.vue";
import store from "@/store";
import axios from "axios";
import { Icon } from "@iconify/vue";
export default {
  name: "services-view",
  data() {
    return {
      data: [],
      shown_data: [],
      search_for: "",
    };
  },
  components: {
    SideBar,
    Icon,
  },
  methods: {
    getData() {
      axios
        .get(store.state.server + "get-all-services")
        .then((response) => {
          this.data = response.data;
          this.SearchByName();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SearchByName() {
      this.shown_data =
        this.search_for === ""
          ? this.data
          : this.data.filter(
              (item) =>
                item.name_ar.includes(this.search_for) ||
                item.name_en
                  .toLowerCase()
                  .includes(this.search_for.toLocaleLowerCase())
            );
    },
    DeleteService(id) {
      let conf = window.confirm("هل تريد الحذف؟");
      if (conf) {
        axios
          .get(store.state.server + "delete-service/" + id)
          .then((response) => {
            if (response.status == 200) {
              location.reload();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
